import React from 'react';
import rangeSlider from 'range-slider-input';
import 'range-slider-input/dist/style.css';

class Slider extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      min: props.min || 0,
      max: props.max || 100,
      from: props.min || 0,
      to: props.max || 100,
      value: [props.min || 0, props.max || 100]
    };

    this.slider = null;
  }

  componentDidMount() {
    const { min, max, value } = this.state;

    this.slider = rangeSlider(this.sliderRef, {
      min,
      max,
      value,
      step: 0.1,
      onInput: this.valuesChanged,
      onThumbDragEnd: this.handleThumbDragEnd,
    });
  }

  componentDidUpdate(prevProps) {
    const { min, max } = this.props;
    if (min !== prevProps.min || max !== prevProps.max) {
      this.setState({ min, max, value: [min, max] });

      this.slider.min(min);
      this.slider.max(max);
      this.slider.value([min, max]);
    }
  }

  handleThumbDragEnd = () => {
    this.props.changeFromTo(this.state.from, this.state.to);
  };

  valuesChanged = (values) => {
    this.setState({
      from: values[0],
      to: values[1],
      value: values
    });
  };

  changeFromValue = (value) => {
    const newValue = Math.min(Math.max(parseFloat(value), this.state.min), this.state.to);
    this.setState({ from: newValue, value: [newValue, this.state.value[1]] }, () => {
      this.props.changeFromTo(this.state.from, this.state.to);
    });
    this.slider.value([newValue, this.state.value[1]]);
  };

  changeToValue = (value) => {
    const newValue = Math.max(Math.min(parseFloat(value), this.state.max), this.state.from);
    this.setState({ to: newValue, value: [this.state.value[0], newValue] }, () => {
      this.props.changeFromTo(this.state.from, this.state.to);
    });
    this.slider.value([this.state.value[0], newValue]);
  };

  render() {
    return (
      <div className="slider-container">
        <div className="inputs-container">
          <input 
            type="number" 
            value={this.state.from} 
            onChange={(e) => this.changeFromValue(e.target.value)} 
          /> - 
          <input 
            type="number" 
            value={this.state.to} 
            onChange={(e) => this.changeToValue(e.target.value)} 
          />
        </div>
        <div ref={(el) => (this.sliderRef = el)} className="slider" />
      </div>
    );
  }
}

export default Slider;
